import React, { PureComponent } from 'react';
import { Button } from 'antd-mobile';

import './index.less';

class Btn extends PureComponent {
  static defaultProps = {
    style: {},
  };

  // componentWillReceiveProps(nextProps, nextContext) {
  //   const { disabled, text } = nextProps;
  //   this.setState({
  //     disabled,
  //     text,
  //   });
  // }

  render() {
    const { className, onClick, key, text, style, disabled } = this.props;
    return (
      <Button
        style={style}
        activeStyle={{ background: '#ccc' }}
        className={`button ${className || ''}`}
        onClick={onClick}
        key={key}
        disabled={disabled}
      >
        {text}
      </Button>
    );
  }
}

export default Btn;



// WEBPACK FOOTER //
// ./src/components/Btn/index.js